import { createApp, defineAsyncComponent } from 'vue';
import store from '@/store';
import StepAddress from '@/components/SolarLeadForm/StepAddress.vue';
import BaseSpacer from '@/components/BaseSpacer.vue';
import BaseLoader from '@/components/BaseLoader.vue';
import BaseEqualizer from '@/components/BaseEqualizer.vue';
import BasePageLoader from '@/components/BasePageLoader.vue';
import BaseEqualizerElement from '@/components/BaseEqualizerElement.vue';
import BaseEqualizerElementPart from '@/components/BaseEqualizerElementPart.vue';
import App from './App.vue';
import '@/interfaces/WindowInterface';

const SolarLeadForm = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/solar-lead-form" */ '@/components/SolarLeadForm.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepMontage = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-montage" */ '@/components/SolarLeadForm/StepMontage.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepRoof = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-roof" */ '@/components/SolarLeadForm/StepRoof.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepPower = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-power" */ '@/components/SolarLeadForm/StepPower.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepWallbox = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-wallbox" */ '@/components/SolarLeadForm/StepWallbox.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepContact = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-personal" */ '@/components/SolarLeadForm/StepContact.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepOverview = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-overview" */ '@/components/SolarLeadForm/StepOverview.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});
const StepSuccess = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: "chunks/step-overview" */ '@/components/SolarLeadForm/StepSuccess.vue'),
  loadingComponent: BasePageLoader,
  delay: 0,
});

const Checkbox = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/text-sections" */ '@/components/Checkbox.vue'));
const BaseButton = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/text-sections" */ '@/components/BaseButton.vue'));
const InputField = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/text-sections" */ '@/components/InputField.vue'));
const SelectField = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/text-sections" */ '@/components/SelectField.vue'));

const ioApp = createApp(App)
  .component('BaseSpacer', BaseSpacer)
  .component('BaseLoader', BaseLoader)
  .component('BaseEqualizer', BaseEqualizer)
  .component('BaseEqualizerElement', BaseEqualizerElement)
  .component('BaseEqualizerElementPart', BaseEqualizerElementPart)
  .component('StepAddress', StepAddress)

  .component('SolarLeadForm', SolarLeadForm)
  .component('StepMontage', StepMontage)
  .component('StepRoof', StepRoof)
  .component('StepPower', StepPower)
  .component('StepWallbox', StepWallbox)
  .component('StepContact', StepContact)
  .component('StepOverview', StepOverview)
  .component('StepSuccess', StepSuccess)

  .component('Checkbox', Checkbox)
  .component('BaseButton', BaseButton)
  .component('InputField', InputField)
  .component('SelectField', SelectField)

  .use(store);

ioApp.mount('#io-shop-solar');
